module.exports = __webpack_public_path__ + "static/img/googlecalendar1.6721a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/googlecalendar1.png
// module id = 1422
// module chunks = 1